import { cn, formatPrice } from "@/lib/utils";
import { useLocale } from "next-intl";

export default function PriceTag({
  price,
  discount,
  className,
  decimal = true,
}) {
  const locale = useLocale();
  const formattedPrice = formatPrice(price, locale, decimal);
  switch (discount?.type) {
    case "sale":
      return (
        <div className="flex flex-wrap gap-2">
          <p className={cn("text-lg font-bold text-primary", className)}>
            {formattedPrice}
          </p>
          <p
            className={cn(
              "text-base font-medium text-destructive underline underline-offset-4",
              className,
            )}
          >
            {discount.toBeApplicable} achetés = -{discount.percentage}%
          </p>
        </div>
      );

    case "gift":
      return (
        <div className="flex flex-wrap gap-2">
          <p className={cn("text-lg font-bold text-primary", className)}>
            {formattedPrice}
          </p>
          <p
            className={cn(
              "text-base font-medium text-destructive underline underline-offset-4",
              className,
            )}
          >
            {discount.toBeApplicable} achetés = {discount.giftedNumber} offerts
          </p>
        </div>
      );

    case "discount":
      const discountedPrice = formatPrice(
        price - price * (discount.percentage / 100),
        locale,
        decimal,
      );
      return (
        <div className="flex flex-wrap items-center gap-2">
          <p
            className={cn(
              "text-base font-medium text-muted line-through",
              className,
            )}
          >
            {formattedPrice}
          </p>
          <p className={cn("text-lg font-bold text-primary", className)}>
            <span>{discountedPrice}</span>{" "}
            <bdi
              className={cn("text-sm font-medium text-destructive", className)}
            >
              (-{discount.percentage}%)
            </bdi>
          </p>
        </div>
      );
    case "none":
    default:
      return (
        <div className={cn("text-lg font-bold text-primary", className)}>
          {formattedPrice}
        </div>
      );
  }
}
